import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FontBody1WeightSemiBold, FontWeightNormal } from 'autogen/design-tokens/tokens';
import type { FilterOptionViewModel } from 'autogen/swagger/all';
import { Sorting } from 'autogen/translation-keys/trans-website-filter';
import { ButtonWithIcon } from 'components/Button';
import Icon from 'components/Icon';
import { breakpoint, sizes } from 'variables';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import { sortingFilterMenuId } from './SortingFilterMenu';

const StyledText = styled.span`
    display: none;
    font-weight: ${FontBody1WeightSemiBold};

    ${breakpoint.up(sizes.sm)} {
        display: inline-block;
    }
`;

const DisplayName = styled.span`
    font-weight: ${FontBody1WeightSemiBold};
    ${breakpoint.up(sizes.sm)} {
        font-weight: ${FontWeightNormal};
    }
`;

export default function SortingFilterMenuOpener({ model: sortingOptions }: { model: FilterOptionViewModel[] }) {
    const filterMenuId = sortingFilterMenuId;
    const { openFilterMenu } = useFilterMenu(filterMenuId, false);
    const { t } = useTranslation();
    const selectedOption = sortingOptions.find((option) => option.isSelected);

    if (!selectedOption) return null;

    return (
        <ButtonWithIcon
            icon={<Icon type="ChevronDown" size={16} />}
            iconProperties={{ position: 'right' }}
            variant="ghostOnLight"
            size="sm"
            onClick={openFilterMenu}
        >
            <span>
                <StyledText>{t(Sorting)}:</StyledText> <DisplayName>{selectedOption.displayName}</DisplayName>
            </span>
        </ButtonWithIcon>
    );
}
